import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

const MyModalButton = ({
  loading,
  disabled,
  className,
  onClick,
  text,
  type,
  icon,
}) => {
  return (
    <button
      className={
        `${className} inline-flex w-28 justify-center gap-2 rounded-md border px-4 py-2 ` +
        'text-base font-medium focus:outline-none focus:ring-2 focus:ring-offset-2' +
        'hover:opacity-90 sm:text-sm'
      }
      disabled={disabled}
      onClick={onClick}
      type={type ? type : 'button'}
    >
      {loading && (
        <span className="flex items-center">
          <FontAwesomeIcon
            aria-hidden="true"
            className="h-5 w-5 animate-spin text-white"
            icon={icon}
          />
        </span>
      )}
      {text}
    </button>
  )
}

export default MyModalButton

MyModalButton.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  type: PropTypes.string,
  icon: PropTypes.any,
}
